import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { api, fileUrl } from "@/lib/api";

export const StorySection = () => {
  const { t } = useLanguage();
  const [blocks, setBlocks] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (!initialized) {
    setInitialized(true);
    api
      .get("/story")
      .then((res) => setBlocks(res.data || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }

  if (!loaded || blocks.length === 0) return null;

  return (
    <section
      data-testid="story-section"
      className="border-t border-zinc-800 px-6 md:px-12 lg:px-16 py-24 md:py-32"
    >
      <div className="max-w-3xl mb-16">
        <div className="text-xs tracking-[0.3em] uppercase text-[#ff5a00] font-mono mb-3">
          / 02 — {t.story.eyebrow}
        </div>
        <h2 className="font-display text-5xl md:text-7xl uppercase leading-none">
          {t.story.title}
        </h2>
        <p className="mt-6 text-zinc-400 text-base md:text-lg">{t.story.lead}</p>
      </div>

      <div className="space-y-20 md:space-y-28">
        {blocks.map((block, i) => {
          const reverse = i % 2 === 1;
          const hasImage = !!block.image_url;
          return (
            <article
              key={block.id}
              data-testid={`story-block-${block.id}`}
              className={`grid grid-cols-1 ${
                hasImage ? "lg:grid-cols-12" : ""
              } gap-8 lg:gap-16 items-center`}
            >
              {hasImage && (
                <div
                  className={`lg:col-span-7 ${reverse ? "lg:order-2" : ""}`}
                >
                  <div className="relative overflow-hidden border border-zinc-800 group">
                    <img
                      src={fileUrl(block.image_url)}
                      alt={block.title}
                      className="w-full h-full object-cover aspect-[4/3] grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-4 left-4 text-[10px] font-mono tracking-[0.3em] text-white bg-black/70 px-2 py-1 backdrop-blur-sm">
                      {String(i + 1).padStart(2, "0")} / {String(blocks.length).padStart(2, "0")}
                    </div>
                  </div>
                </div>
              )}
              <div className={hasImage ? "lg:col-span-5" : ""}>
                <div className="text-[10px] font-mono tracking-[0.3em] text-[#ff5a00] mb-3">
                  {t.story.chapter.toUpperCase()} {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display text-4xl md:text-5xl uppercase leading-tight">
                  {block.title}
                </h3>
                {block.body && (
                  <p className="mt-6 text-zinc-300 leading-relaxed whitespace-pre-line text-base md:text-lg">
                    {block.body}
                  </p>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};
